module.exports = __webpack_public_path__ + "img/item3.1b9cc559.png";